import { Component, OnInit } from '@angular/core';
import { MatchService } from '../match.service';
import swal from "sweetalert2";
import { UserService } from '../user.service';

@Component({
  selector: 'app-all-match',
  templateUrl: './all-match.component.html',
  styleUrls: ['./all-match.component.css']
})
export class AllMatchComponent implements OnInit {

  match: any;
  isLoading = false;
  level = '0';
  constructor(private matchService: MatchService, private userService: UserService) { }

  ngOnInit() {
    this.isLoading = true;
    this.level = this.userService.getUserLevel();
    this.matchService.getAllMatches();
    this.matchService.getUpdateAllMatchListner()
      .subscribe((response) => {
        //console.log(response);
        this.isLoading = false;
        this.match = response.allMatch;
      },
        error => {
          console.log(error);
        });
  }

  upperCaseStr(str) {
    //return str.toUpperCase();
    console.log(str);
  }

  rollbackMatch(inc, eventId) {
    var btn = document.getElementById('mbtn' + inc);
    var process = document.getElementById('mprocess' + inc);
    btn.style.display = 'none';
    process.style.display = 'block';

    this.matchService.matchRollBack(eventId).subscribe((response) => {
      //console.log(response);
      this.msgSuccess();
      this.matchService.getAllMatches();
      btn.style.display = 'block';
      process.style.display = 'none';
    },
      error => {
        //console.log(error);
        btn.style.display = 'block';
        process.style.display = 'none';
        this.msgFailure();
      });
  }

  msgSuccess() {
    swal.fire({
      icon: 'success',
      title: 'Successfully Update!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  msgFailure() {
    swal.fire({
      icon: 'error',
      title: 'Something Went Wrong!',
      showConfirmButton: false,
      timer: 1500
    })
  }
}